'use strict';

import navigation from './navigation';
import regionCharts from './charts/region-charts';
import mainCharts from './charts/main-charts';
import ageCharts from './charts/age-charts';
import municipalityCharts from './charts/municipality-charts';
import medicalCharts from './charts/medical-charts';
import vaccineCharts from './charts/vaccine-charts';
import sewageCharts from './charts/sewage-charts';
import dataLoader from './data-loader';
import loader from './loader';

const covid = (function(){
    let dateElems, rateElems;
    let pages = null;
    let data = null;

    function getPageChart(id) {
        let pageChart = null;
        if (id === window.config.defaultPageId) {
            pageChart = mainCharts;
        } else if (id === window.config.hospitalPageId) {
            pageChart = medicalCharts;
        } else if (id === window.config.regionPageId) {
            pageChart = regionCharts;
        } else if (id === window.config.municipalityPageId) {
            pageChart = municipalityCharts;
        } else if (id === window.config.agePageId) {
            pageChart = ageCharts;
        } else if (id === window.config.vaccinePageId) {
            pageChart = vaccineCharts;
        } else if (id === window.config.sewagePageId) {
            pageChart = sewageCharts;
        }

        return pageChart;
    }

    function openPage(loadedData, { id, page, dataReload }) {
        data = loadedData;
        const charts = getPageChart(id);

        if (!page.classList.contains('initialized')) {
            page.classList.add('initialized');
            setTimeout(function(){
                if (charts) {
                    charts.init(data, page);
                }
                loader.end(page);
            }, 1);
        } else if (page.classList.contains('reload')) {
            setTimeout(function(){
                if (charts) {
                    charts.reload(data, page, dataReload);
                }
                loader.end(page);
            }, 1);
        } else {
            // I dont even
            loader.end(page);
        }
    }

    function renderPage(dataReload = false, initialLoad = false) {
        /*// Make sure we have up to date content
        const countElem = document.querySelector('.count-confirmed .count');
        const visibleCount = countElem && countElem.dataset && countElem.dataset.count ? parseInt(countElem.dataset.count) : data.count;

        if (data.count > visibleCount && !window.location.search) {
            // Easy fix to show new values in stats
            window.location.href = window.location.origin + window.location.pathname + '?r=1';
        }

        // remove reload string
        if (window.location.search === '?r=1' && window.history && typeof window.history.replaceState === 'function') {
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        // Update data update time
        if (data.updateDateTime) {
            document.getElementById('js-data-updated').innerHTML = data.updateDateTime;
        }*/

        const id = navigation.getActivePageId();
        const dataEndpoints = dataLoader.getPageDataEndpoints(data, id);
        const page = document.getElementById(id);

        if (!initialLoad) {
            loader.start(page);
        }
        dataLoader.loadEndpointData(data, dataEndpoints, openPage, { id, page, dataReload }, null, initialLoad);
    }

    function initTableClick() {
        document.addEventListener('click', function (event) {
            if (window.innerWidth < 941) {
                return;
            }

            const parentTr = event.target.closest('tr');
            if (parentTr) {
                // Find dataset id from tds
                for (let i=0; i<= parentTr.children.length - 1; i++) {
                    const item =  parentTr.children[i];
                    const datasetId = item.getAttribute('data-dataset-id');
                    if (datasetId) {
                        const sectionElem = event.target.closest('.section');
                        const multiselectElem = sectionElem ? sectionElem.querySelector('.multiselect') : null;
                        if (multiselectElem) {
                            const input = multiselectElem.querySelector('input[value="'+datasetId+'"]');
                            if (input) {
                                input.click();
                            }

                            const clearDataset = item.getAttribute('data-clear-dataset');
                            if (clearDataset) {
                                // Clear this dataset if checked
                                const clearInput = multiselectElem.querySelector('input[value="'+clearDataset+'"]:checked');
                                if (clearInput) {
                                    clearInput.click();
                                }
                            }
                        }
                        break;
                    }
                }
            }
        });
    }

    function updateDateStrings() {
        // Change date strings
        const formattedDate = window.config.firstDate.format('D.M.YYYY');
        dateElems.forEach((elem) => {
            elem.textContent = formattedDate;
        });
    }

    function updateRateStrings() {
        // Change date strings
        rateElems.forEach((elem) => {
            elem.textContent = window.config.rateDays;
        });
    }

    /*function initData(respData) {
        data = respData;

        // Make sure we have up to date content
        const countElem = document.querySelector('.count-confirmed .count');
        const visibleCount = countElem && countElem.dataset && countElem.dataset.count ? parseInt(countElem.dataset.count) : data.count;

        if (data.count > visibleCount && !window.location.search) {
            // Easy fix to show new values in stats
            window.location.href = window.location.origin + window.location.pathname + '?r=1';
        }

        // remove reload string
        if (window.location.search === '?r=1' && window.history && typeof window.history.replaceState === 'function') {
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        // Update data update time
        if (data.updateDateTime) {
            document.getElementById('js-data-updated').innerHTML = data.updateDateTime;
        }

        // Create page charts
        renderPage(false, true);
    }*/

    /*function reloadData(respData) {
        data.ages = respData.ages;
        data.municipalities = respData.municipalities;

        addPageClass('reload-date');
        updateDateStrings();
        renderPage(true);
    }*/

    function addPageClass(className) {
        for (let page of pages) {
            if (page.classList.contains('initialized')) {
                if (!page.classList.contains(className)) {
                    page.classList.add(className);
                }
                if (!page.classList.contains('reload')) {
                    page.classList.add('reload');
                }
            }
        }
    }

    function reinitDates() {
        addPageClass('reload-date');
        updateDateStrings();
        renderPage();
    }

    function reinitIncidenceRates() {
        addPageClass('reload-rate');
        updateRateStrings();
        renderPage();
    }

    function reinitWave() {
        addPageClass('reload-wave');
        renderPage();
    }

    function init() {
        initTableClick();

        pages = document.getElementsByClassName('page-section');
        for (let page of pages) {
            page.addEventListener('page-open', renderPage);
        }

        rateElems = document.querySelectorAll('.js-rate');
        updateRateStrings();

        dateElems = document.querySelectorAll('.js-date');
        updateDateStrings();

        // Create page charts
        renderPage(false, true);
    }

    return {
        init,
        //reloadData,
        reinitDates,
        reinitWave,
        reinitIncidenceRates
    }
})();

export default covid;
